/* eslint-disable react/display-name */
// import PharmacyList from './pharmacy-list-management/pharmacy-list';

import { ComingSoonCard } from 'app/components/atoms';

const LogsManagementConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/log-management/log-list',
      component: ComingSoonCard,
      title: 'Log Yönetimi ',
      isAuthProtected: true
    }
  ]
};

export default LogsManagementConfig;
